import React, { useEffect, useState } from 'react';

import GlobalMarkupOptions from '@nerdwallet/coin/GlobalMarkupOptions';
import appConfig from '@nerdwallet/app-config';
import useAnalytics from './useAnalytics';
import usePageViewId from '~/client/lib/segment/usePageViewId';

type SegmentTrackingProps = {
  segmentPageName: string;
};

const SegmentTracking = ({
  segmentPageName,
}: SegmentTrackingProps): JSX.Element => {
  const { trackSegmentPageEvent } = useAnalytics();
  const [isAvailable, setIsAvailable] = useState(false);
  const pageViewId = usePageViewId();

  useEffect(() => {
    const timeout = setInterval(() => {
      const setHeaderPropsIsAvailable =
        typeof window !== undefined &&
        typeof window.nerdwallet?.ui?.setHeaderProps === 'function';
      if (setHeaderPropsIsAvailable) {
        setIsAvailable(true);
        clearInterval(timeout);
      }
    }, 100);
  }, []);

  useEffect(() => {
    if (!isAvailable) return;

    window.nerdwallet?.ui?.setHeaderProps({
      segmentTrackingAttributes: { driverPageViewId: pageViewId },
    });
    trackSegmentPageEvent(segmentPageName, pageViewId);
  }, [pageViewId, isAvailable, trackSegmentPageEvent, segmentPageName]);

  return (
    <div>
      <GlobalMarkupOptions>
        {{
          segmentTrackingAttributes: {
            driverPageName: segmentPageName,
            // eslint-disable-next-line no-underscore-dangle
            deployableName: appConfig?._meta?.deployable,
            // eslint-disable-next-line no-underscore-dangle
            deployableVersion: appConfig?._meta?.version,
          },
        }}
      </GlobalMarkupOptions>
    </div>
  );
};

export default SegmentTracking;
